// extracted by mini-css-extract-plugin
module.exports = {"container":"_2zd2W0","mobile-items":"_1ylbKX","horizontal-items":"_2DcJ4a","errorBlock":"_1vZOVy"};